/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { uuid4 } from '../../utils';
import FabricCanvasExercise, { Props } from '../fabricexercise';
import { drawCircle, Type } from '../utils';
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric';
import { PageIcon, PageItemCanvasModel } from '@/types';

class DragAndDrop extends FabricCanvasExercise {
  pageItem: PageItemCanvasModel | undefined;
  matchingItems: any[] = [];
  activityType: any;
  currentPageItem!: PageItemCanvasModel;
  targets: any[] = [];
  sources: any[] = [];
  activityBackgroundImage: string | undefined;
  async configureCanvas(props: Props) {
    this.pageItem = props.currentPageItem;
    this.matchingItems = [];
    this.activityType = props.currentPageItem.exerciseType;
    this.currentPageItem = props.currentPageItem;
    this.currentPageItem = props.currentPageItem;
    this.activityBackgroundImage = props.activityBackgroundImage;
    if (this.pageItem && this.pageItem.targets) {
      this.targets = await this.addTargets(this.pageItem.targets);
    }
    if (this.pageItem && this.pageItem.sources && this.pageItem.targets) {
      this.sources = await this.addSources(
        this.pageItem.sources,
        this.pageItem.targets,
        props.currentPageItem.pageImage,
        this.activityBackgroundImage,
      );
      this.sources.forEach(function (source) {
        source.originalLeft = source.left;
        source.originalTop = source.top;
      });
    }

    this.renderActivityFiles(props.currentPageItem, props.onQuestionFileClick);
  }

  addSources = async (
    sources: PageIcon[],
    targets: PageIcon[],
    pageImage: string,
    activityBackgroundImage: string,
  ) => {
    const sourceList = [];
    let index = 0;
    let minHeight = 1000000;

    const objects = this.activityType === Type.ManyToMany ? sources : targets;
    for (const o of objects) {
      let objHeight = o.height ? o.height : 1000000;
      if (this.activityType === Type.ManyToMany) {
        objHeight = o.height;
      }
      if (objHeight < minHeight) {
        minHeight = objHeight;
      }
    }
    const imagePosition = this._canvas.getBackgroundImageCoordinate();
    this.pageItem || {};
    for (const o of sources) {
      const left = imagePosition.imgLeft + o.x;
      const top = imagePosition.imgTop + o.y;
      let source;
      if (!o.correctAnswer) {
        const bgImage = this._canvas.getBackgroundImage(); // Mevcut arka plan resmini al
        const left = imagePosition.imgLeft + o.x;
        const top = imagePosition.imgTop + o.y;
        const cropX =
          ((o.x) / bgImage.scaleX || 1) +
          (bgImage.cropX || 0);
        const cropY =
          ((o.y) / bgImage.scaleY || 1) +
          (bgImage.cropY || 0);

        const width = o.width / (bgImage.scaleX || 1);
        const height = o.height / (bgImage.scaleY || 1);

        // Kesilmiş resmi oluştur
        source = new fabric.Image(bgImage.getElement(), {
          optionId: o.id,
          targets: o.targets,
          left, // Kesilen resmin kanvasa yerleştirileceği sol koordinat
          top, // Kesilen resmin kanvasa yerleştirileceği üst koordinat
          width, // Orijinal resmin boyutları
          height,
          cropX: cropX, // Kesme işlemi için başlangıç X koordinatı
          cropY: cropY, // Kesme işlemi için başlangıç Y koordinatı
          scaleX: bgImage.scaleX || 1, // Arka plan resminin yatay ölçeği
          scaleY: bgImage.scaleY || 1, // Arka plan resminin dikey ölçeği
          erasable: false,
          isMain: true,
          hasControls: false,
          hasBorders: false,
          id: `source-${index}`,
          name: `source-${index}`,
        });
      } else {
        const rect = new fabric.Rect({
          top,
          left,
          name: `source-rect-${index}`,
          width: o.width,
          height: minHeight,
          oWidth: o.width,
          oHeight: o.height,
          fill: 'transparent',
          opacity: 0.01,
          stroke: 'black',
          visible: false,
          selectable: true,
        });

        // Text elemanını oluşturun
        const text = new fabric.Text(o.correctAnswer, {
          id: `sourcetext-${index}`,
          name: `source-text-${index}`,
          top,
          left,
          fontFamily: 'Arial',
          fontSize: minHeight,
          fill: 'red',
          selectable: false,
          visible: false,
        });

        // Dikdörtgen ve text elemanını bir grup haline getirin
        source = new fabric.Group([rect, text], {
          id: `source-${index}`,
          name: `source-${index}`,
          targets: o.targets,
          optionId: o.id,
          textId: `sourcetext-${index}`,
          correctAnswer: o.correctAnswer,
          pageIcon: true,
          left: rect.left,
          top: rect.top,
          scale: 1,
          erasable: false,
          isMain: true,
          hasControls: false,
          hasBorders: false,
        });
      }
      const width = o.width;
      const height = o.height;
      const sRect = await new fabric.Rect({
        width,
        height,
        pageIcon: true,
        strokeWidth: 1,
        optionId: o.id,
        stroke: 'red',
        rx: 8,
        ry: 8,
        strokeDashArray: [1, 1],
        fill: '',
        left,
        top,
        borderRadius: 10,
        id: `srect-${o.id}`,
        name: `srect-${index}`,
        hasControls: false,
        hasBorders: false,
        erasable: false,
        evented: false,
      });
      this._canvas.addObject(source);
      this._canvas.addObject(sRect);
      source.coordinate = sRect.lineCoords;
      this.setSourceEvents(source);
      sourceList.push(source);
      index++;
    }
    return sourceList;
  };

  setSources = async (source: any, target: any, cloneId: any) => {
    let removedItems = [];
    if (
      (this.activityType === Type.OneToMany ||
        this.activityType === Type.OneToOne) &&
      this.matchingItems
    ) {
      removedItems = this.matchingItems?.filter(
        (x) => x.targetId === target.id && x.optionId !== source.optionId,
      );
      this.removeItems(removedItems);
    }
    if (source.isMain) {
      await this.createClone(source, target, cloneId);
      this.backToOrginal(source);
    } else {
      this.placeItem(source, target);
    }
  };

  setSourceEvents = (source: any) => {
    const openDrawingMode = this.openDrawingMode;
    const closeDrawingMode = this.closeDrawingMode;
    const selectedTool = this.selectedTool;
    const checkPosition = this.checkPosition;
    const canvas = this._canvas;
    source.set('draggable', true);
    source.on('mousedown:before', (o: any) => {
      this.setTextVisibilty(source, true, o);
      closeDrawingMode(canvas, selectedTool);
    });
    source.on('mouseup', (o: any) => {
      if (checkPosition) {
        checkPosition(source, o.pointer.x, o.pointer.y);
      } else {
        alert(source.isMain);
      }
      openDrawingMode(canvas, selectedTool);
    });
  };

  setTextVisibilty = (source: any, isVisible: boolean, point?: any) => {
    if (source._objects && source.correctAnswer) {
      const rect = source._objects.find((x: any) =>
        x.name.includes('source-rect'),
      );
      const text = source._objects.find((x: any) =>
        x.name.includes('source-text'),
      );
      rect.set('visible', isVisible);
      rect.set('height', text.fontSize);
      text.set('visible', isVisible);
      text.set({
        left: rect.left,
        top: rect.top + rect.height / 2 - text.height / 2,
      });
      rect.set('width', text.width);
      if (point) {
        source.set('left', point.absolutePointer.x - text.width / 2);
        source.set('top', point.absolutePointer.y - text.height / 2);
      }
    }
  };
  addTargets = async (targets: PageIcon[]) => {
    const imagePosition = this._canvas.getBackgroundImageCoordinate();

    const targetList = [];
    let index = 0;
    const gradient = new fabric.Gradient({
      type: 'linear',
      coords: { x1: 0, y1: 0, x2: 200, y2: 0 },
      colorStops: [
        { offset: 0, color: ' #4350af' },
        { offset: 1, color: '#2962cb' },
      ],
    });

    for (const o of targets) {
      const left = imagePosition.imgLeft + o.x;
      const top = imagePosition.imgTop + o.y;
      const target = await new fabric.Rect({
        width: o.width,
        height: o.height,
        pageIcon: true,
        targetId: o.id,
        strokeWidth: 1,
        optionId: o.id,
        stroke: gradient,
        rx: 8,
        ry: 8,
        fill: '',
        left,
        top,
        borderRadius: 10,
        shadow: 'rgba(0, 0.3, 0.3, 0.3) 15px 15px 15px',
        id: `target-${o.id}`,
        name: `target-${index}`,
        hasControls: false,
        hasBorders: false,
        erasable: false,
        evented: false,
        isTarget: true,
        matchingSources: [],
      });
      this._canvas.addObject(target);
      targetList.push(target);
      index++;
    }
    return targetList;
  };

  backToOrginal = (source: any) => {
    this.setTextVisibilty(source, false);
    source.animate(
      {
        left: source.originalLeft,
        top: source.originalTop,
      },
      {
        duration: 100,
        onChange: () => this._canvas.canvasRenderAll(), // Doğru kullanım
      },
    );
  };

  removeItems = (removedItems: any) => {
    for (const item of removedItems) {
      const obj = this._canvas.getObjects().find((x) => x.id === item.sourceId);
      if (obj && !item.isMain && this.matchingItems) {
        this.matchingItems = this.matchingItems.filter(
          (x) => x.sourceId !== item.sourceId,
        );
        this.removeDrawLine(obj);
        this._canvas.removeObject(obj);
      } else if (obj && item.isMain) {
        this.backToOrginal(obj);
      }
    }
    this._canvas.canvasRenderAll();
  };

  placeItem = (source: any, target: any) => {
    let sourceWidth = source.width;
    let sourceHeight = source.height;
    let targScale = 0.7 *(source.scaleX ??1);
    if (source.type === 'group') {
      const rect = source._objects[0];
      sourceWidth = rect.width;
      sourceHeight = rect.height;
      targScale = 0.9;
    }
    const canvas = this._canvas;
    const leftCenter =
      target.left + (target.width - sourceWidth * targScale) / 2;
    if (
      this.activityType === Type.OneToMany ||
      this.activityType === Type.OneToOne
    ) {
      const topCenter =
        target.top + (target.height - sourceHeight * targScale) / 2;
      if (source) {
        source.scale(targScale);
        source.animate(
          {
            left: leftCenter,
            top: topCenter,
            opacity: 1,
          },
          {
            duration: 100,
            onChange: canvas.canvasRenderAll(),
          },
        );
      }
    } else {
      let topCenter = target.top;
      let index = 0;
      if (this.matchingItems) {
        const existingItems = this.matchingItems.filter(
          (x) => x.targetId === target.id,
        );
        for (const item of existingItems) {
          const object = canvas
            .getObjects()
            .find((x) => x.id === item.sourceId);
          if (index !== 0 && object) {
            topCenter += object.height * targScale + 10 * targScale;
          }
          index++;
          if (object) {
            object.animate(
              {
                top: topCenter,
                opacity: 1,
              },
              {
                duration: 100,
                onChange: canvas.canvasRenderAll(),
              },
            );
          }
        }
      }

      source.animate(
        {
          left: leftCenter,
          top: topCenter,
          opacity: 1,
        },
        {
          duration: 100,
          onChange: canvas.canvasRenderAll(),
        },
      );
    }
  };

  createClone = async (source: any, target: any, id: number) => {
    const canvas = this._canvas;
    const clones = canvas
      .getObjects()
      .filter((x) => x.optionId === source.optionId);
    const setSourceEvents = this.setSourceEvents;
    const setTextVisibilty = this.setTextVisibilty;

    const placeItem = this.placeItem;
    await source.clone(function (clone: any) {
      canvas.addObject(
        clone.set({
          id,
          name: `clone${clones.length - 1}-${source.id}`,
          optionId: source.optionId,
          pageIcon: true,
          isClone: true,
          opacity: 1,
          erasable: false,
          hasControls: false,
          hasBorders: false,
          originalLeft: source.originalLeft,
          originalTop: source.originalTop,
          coordinate: source.coordinate,
          targets: source.targets,
        }),
      );
      setSourceEvents(clone);
      setTextVisibilty(clone, true);
      placeItem(clone, target);
    });
    return id;
  };

  checkPosition = async (
    source: any,
    x: number,
    y: number,
    playAudio: boolean = true,
  ) => {
    const canvas = this._canvas;
    let isOnTarget = false;
    let isSame = false;
    for (const target of this.targets) {
      // var audio = new Audio(`${process.env.PUBLIC_URL}/assets/sound/click.mp3`);
      // audio.play();
      if (target.containsPoint(new fabric.Point(x, y))) {
        isSame =
          this.matchingItems.filter(
            (x) => x.targetId === target.id && x.sourceId === source.id,
          ).length !== 0;
        if (
          !this.matchingItems.find(
            (x) => x.targetId === target.id && x.optionId === source.optionId,
          )
        ) {
          const isCorrect =
            source.targets.filter((x: any) => x.id === Number(target.optionId))
              .length !== 0;
          if (!this.currentPageItem.hasCompleteButton && playAudio) {
            this.playSound(isCorrect);
            if (!isCorrect) {
              break;
            }
          }

          this.matchingItems = this.matchingItems.filter(
            (x) => x.sourceId !== source.id,
          );
          const cloneId = source.isMain ? uuid4() : source.id;
          this.matchingItems.push({
            targetId: target.id,
            optionId: source.optionId,
            sourceId: cloneId,
            isCorrect,
          });

          this.setSources(source, target, cloneId);
          const existingSources = this.matchingItems.filter(
            (x) => x.optionId === source.optionId,
          );
          if (
            existingSources.length === source.targets.length &&
            source.isMain
          ) {
            this.drawLine(source);
          }
          isOnTarget = true;
          break;
        }
      }
    }
    if (!isOnTarget && !isSame) {
      this.matchingItems = this.matchingItems.filter(
        (x) => x.sourceId !== source.id,
      );
      if (!source.isMain) {
        this.removeDrawLine(source);
        canvas.removeObject(source);
      } else {
        this.backToOrginal(source);
      }
    }
  };

  onComplete = () => {
    const canvas = this._canvas;
    const objects = canvas.getObjects();
    for (const item of this.matchingItems) {
      const source = objects.find((x) => x.id === item.sourceId);
      const circle = drawCircle(source.left, source.top, 10, item.isCorrect);
      canvas.addObject(circle.circle);
      canvas.addObject(circle.iconShape);
    }
    canvas.canvasRenderAll();

    return this.matchingItems;
  };

  onReset = () => {
    this.resetOpenedAnswers();
    const canvas = this._canvas;
    const objects = canvas.getObjects();
    for (const item of this.matchingItems) {
      const answer = canvas.getObjects().find((x) => x.id === item.sourceId);
      canvas.removeObject(answer);
    }
    // const lines = objects.filter((x) => x.clearOnReset === true)
    // for (const line of lines) {
    //   canvas.remove(line)
    // }
    // const checkedAnswers = objects.filter(
    //   (x) => x.id && x.id.includes('checkedAnswer')
    // )
    // for (const checkedAnswer of checkedAnswers) {
    //   canvas.remove(checkedAnswer)
    // }
    const controlledItems = objects.filter(
      (x) =>
        x.id && (x.id.includes('checkshape') || x.id.includes('checkcircle')),
    );
    for (const controlledItem of controlledItems) {
      canvas.removeObject(controlledItem);
    }
    canvas.canvasRenderAll();
    for (const source of this.sources) {
      this.removeDrawLine(source);
      // source.set('evented', true)
      // source.set('opacity', 1)
      // source.set('isDisable', false)
    }
    this.matchingItems = [];
  };

  onShowAnswer = async () => {
    this.onReset();
    const canvas = this._canvas;
    const objects = canvas.getObjects();
    for (const source of objects.filter((x) => x.isMain)) {
      this.setTextVisibilty(source, true);
      for (const target of source.targets) {
        const t = objects.find((x) => x.id === `target-${target.id}`);
        if (t) {
          const targetCenterPoint = this.getTargetCenter(t);
          this.checkPosition(
            source,
            targetCenterPoint.x,
            targetCenterPoint.y,
            false,
          );
        }
        this.addOpenedAnswers(source.optionId);
        // await timer(50)
      }
    }
    this.playSound('solve');
  };
  onShowPreviousAnswer = async () => {
    const canvas = this._canvas;
    const allObjects = canvas.getObjects();
    if (this.matchingItems.length > 0) {
      const matchingItem = this.matchingItems[this.matchingItems.length - 1];
      if (matchingItem) {
        this.matchingItems = this.matchingItems.filter(
          (x) => x !== matchingItem,
        );
        const answer = allObjects.find((x) => x.id === matchingItem.sourceId);
        if (answer) {
          canvas.removeObject(answer);
        }
        this.removeDrawLine(answer);
        canvas.canvasRenderAll();
      }
    }
  };

  onShowNextAnswer = async () => {
    const objectList: any[] = [];
    const targets = this.targets;
    const matchingItems = this.matchingItems;
    const intersectsY = this.intersectsY;
    this.sources.forEach(function (source) {
      const existingMatching = matchingItems.filter(
        (x) => x.optionId === source.optionId,
      );
      if (!(existingMatching.length === source.targets.length)) {
        for (let i = 0; i < source.targets.length; i++) {
          const targetIdExists = existingMatching.some(
            (match) => match.targetId === `target-${source.targets[i].id}`,
          );
          if (!targetIdExists) {
            const target = targets.find(
              (x) => x.optionId === source.targets[i].id.toString(),
            );
            objectList.push({
              source,
              target,
              sourceId: source.id,
              targetId: target.id,
              targetLeft: target.left,
              targetTop: target.top,
              targetWidth: target.width,
              targetHeight: target.height,
            });
          }
        }
      }
    });
    objectList.sort((a, b) => {
      if (intersectsY(a, b)) {
        if (a.targetLeft < b.targetLeft) return -1;
        if (a.targetLeft > b.targetLeft) return 1;
        return 0;
      }
      return a.targetTop - b.targetTop;
    });
    const obj = objectList[0];
    if (obj) {
      const targetCenterPoint = this.getTargetCenter(obj.target);
      this.setTextVisibilty(obj.source, true);
      this.checkPosition(obj.source, targetCenterPoint.x, targetCenterPoint.y);
    }
  };
  destroy() {}
  doMouseDown(o: any) {}

  doMouseMove(o: any) {}

  doMouseUp(o: any) {
    const canvas = this._canvas;
    const objects = canvas.getObjects().filter((x) => x.pageIcon);
    objects.forEach((obj) => {
      canvas.bringToFront(obj);
    });
    canvas.canvasRenderAll();
  }
}

export default DragAndDrop;
